module.exports = __webpack_public_path__ + "img/buy_super_th.c113b569.png";